import {ReactNode, RefObject} from "react";
import {Device} from "../../types/device";

type Props = {
    device?: Device;
    detailsRef?: RefObject<HTMLDivElement | null>;
    centerFooter?: ReactNode;
    rightPanel?: ReactNode;
};

type StatCardProps = {
    icon: ReactNode;
    lines: Array<ReactNode>;
};

function StatCard({icon, lines}: StatCardProps) {
    return (
        <div className="border rounded-xl p-4 flex flex-col text-sm text-center justify-center">
            <div className="flex justify-center mb-1">{icon}</div>
            {lines.map((line, index) => (
                <span key={index}>{line}</span>
            ))}
        </div>
    );
}

export default function PhoneHero({device, detailsRef, centerFooter, rightPanel}: Props) {
    const title = device?.brand && device?.model ? `${device.brand} ${device.model}` : device?.model;

    return (
        <div className="grid grid-cols-3 gap-10 scroll-mt-16" ref={detailsRef} id="details">
            <div className="flex justify-center border-r-2 border-black pr-10">
                <img
                    src={device?.image_url ?? ""}
                    className="w-72 object-contain"
                    alt={device?.model ?? "Phone"}
                />
            </div>

            <div className="flex flex-col gap-6">
                <h1 className="text-3xl font-bold scroll-mt-16">{title}</h1>

                <div className="grid grid-cols-2 gap-4">
                    <StatCard
                        icon={
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="text-gray-500">
                                <rect x="2" y="3" width="20" height="14" rx="2" />
                                <path d="M8 21h8M12 17v4" />
                            </svg>
                        }
                        lines={[
                            `Screen ${device?.screen_size_inch ?? ""} ''`,
                            device?.screen_resolution,
                            `${device?.ppi ?? ""} ppi`,
                            device?.screen_type,
                            `${device?.refresh_rate_hz ?? ""} hz`,
                        ]}
                    />
                    <StatCard
                        icon={
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="text-gray-500">
                                <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
                                <circle cx="12" cy="13" r="4" />
                            </svg>
                        }
                        lines={[
                            `Camera: ${device?.number_of_cameras ?? 0} modules`,
                            `${device?.main_camera_mp ?? ""} MP`,
                            `${device?.ultrawide_camera_mp ?? ""} MP`,
                            `${device?.telephoto_camera_mp ?? ""} MP`,
                        ]}
                    />
                    <StatCard
                        icon={
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="text-gray-500">
                                <rect x="2" y="7" width="18" height="11" rx="2" />
                                <path d="M22 11v3" />
                                <path d="M6 11v3M10 11v3M14 11v3" />
                            </svg>
                        }
                        lines={[
                            "Battery",
                            `${device?.battery_capacity_mah ?? ""} mAh`,
                        ]}
                    />
                    <StatCard
                        icon={
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="text-gray-500">
                                <circle cx="12" cy="12" r="10" />
                                <path d="M12 8v4l3 3" />
                            </svg>
                        }
                        lines={[device?.os]}
                    />
                </div>

                {centerFooter}
            </div>

            <div>{rightPanel}</div>
        </div>
    );
}




